export const PRODUCTS_PER_PAGE = 9;

export const PRODUCT_TYPE = {
  DEFAULT: 'DEFAULT',
  SHOP_EVENT: 'SHOP_EVENT',
};

export const PRODUCTS_CAROUSEL_MAX_LENGTH = 12;
export const PRODUCTS_CAROUSEL_MIN_LENGTH = 6;
